'use client';

import { c as _c } from "react/compiler-runtime";
import 'swiper/css';
import 'swiper/css/pagination';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { reviews } from '@/src/constants/Reviews';
import type { IReview } from '../home.interface';
const ReviewCard = t0 => {
  const $ = _c(12);
  const {
    name,
    text,
    occupation
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute left-0 top-0 w-8"><Image src="/images/icons/ic_inverted_comma.svg" alt="" width={32} height={32} /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative z-10">{t1}<div className="absolute left-[2rem] top-0 w-8"><Image src="/images/icons/ic_inverted_comma.svg" alt="" width={32} height={32} /></div></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== text) {
    t3 = <p className="z-20 ml-3 pt-2 text-left text-[17px] font-normal text-[#555659]">{text}</p>;
    $[2] = text;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== name) {
    t4 = <div className="z-20 ml-3 mt-2 text-left text-base font-bold text-[#3D3E40]">{name}</div>;
    $[4] = name;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== occupation) {
    t5 = <div className="z-20 ml-3 text-left text-base text-[#3D3E40]">{occupation}</div>;
    $[6] = occupation;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className="m-6 flex h-[100%] overflow-auto rounded-2xl bg-[#F7FCFF] bg-origin-padding px-6 py-7 md:m-0 md:max-w-lg">{t2}<div className="flex h-full flex-col justify-center">{t3}{t4}{t5}</div></div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
const NavigationView = () => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <button aria-label="backward" className="swiper-back mr-4 mt-1 flex h-5 w-5 items-center justify-center rounded-full border-2 border-[#8A8F99] hover:cursor-pointer"><ChevronLeftIcon className="stroke-3 h-3 w-3 text-[#8A8F99]" /></button>;
    t1 = <div className="swiper-pagination !static !z-0 mt-1 flex !w-auto min-w-[5rem] !shrink-0 flex-nowrap" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mt-6 flex w-full items-center justify-center gap-x-1 md:mt-12">{t0}{t1}<button aria-label="forward" className="swiper-forward ml-4 mt-1 flex h-5 w-5 items-center justify-center rounded-full border-2 border-[#8A8F99] hover:cursor-pointer xl:ml-0"><ChevronRightIcon className="stroke-3 h-3 w-3 text-[#8A8F99]" /></button></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const Reviews = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-center text-[28px] font-medium text-[#3D3E40] md:text-[36px]">Loved by Special Ed Professionals</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-center text-[15px] font-normal text-[#555659] md:text-[18px]">IEP teams trust us for data collection. <br className="md:hidden" />{" "}Here's what they have to say</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [Navigation, Pagination];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      nextEl: ".swiper-forward",
      prevEl: ".swiper-back"
    };
    t4 = {
      el: ".swiper-pagination",
      clickable: true
    };
    t5 = {
      700: {
        slidesPerView: 2,
        spaceBetween: 50
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 60
      }
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="container relative mx-auto mt-20 px-4 md:px-10 lg:px-16">{t0}{t1}<Swiper modules={t2} slidesPerView={1} spaceBetween={10} navigation={t3} pagination={t4} breakpoints={t5} className="mt-8 flex h-[22rem] w-full flex-nowrap md:mt-16 md:h-[15rem]">{reviews.map(_temp)}</Swiper><NavigationView /></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
function _temp(review, index) {
  if (review.type?.includes("carousel")) {
    return <SwiperSlide key={index}><ReviewCard name={review.name} text={review.text} occupation={review.occupation} /></SwiperSlide>;
  }
  return <span key={index} />;
}